import { _ as F } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.unscopables.flat-map-40df3ae6.js";
import "./es.array.map-d821aaf5.js";
import "./es.date.to-string-6ed49878.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import "./es.regexp.to-string-e800d529.js";
import "./web.set-timeout-72b6430f.js";
import { c as j } from "./index-8b07dec9.js";
import { useState as h, useRef as B, useEffect as J } from "react";
import W, { css as w } from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as Q } from "./getMetrics-953aa4f8.js";
import { Image as V } from "./image.js";
import { PhotoGalleryThumbnail as f } from "./photoGalleryThumbnail.js";
import { PhotoGalleryLightbox as X } from "./photosGalleryLightbox.js";
import { jsxs as Y, jsx as a } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./classof-21a3574e.js";
import "./to-string-92a62764.js";
import "./function-apply-4756dee6.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./array-method-is-strict-e5a3c878.js";
import "./es.array.join-c1bca812.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./es.string.trim-6e13db75.js";
import "./string-trim-14e37ad3.js";
import "./mediaDisclosureButton.js";
import "./es.parse-int-d7709701.js";
import "./es.array.reduce-2985ed2c.js";
import "./environment-is-node-a035d787.js";
import "@ucl/shared-component-foundations";
import "./childrenCountCheck-bbe924c6.js";
import "./es.symbol.description-6025a604.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./es.function.bind-b4bdcd4b.js";
import "./es.array.from-fe752fa6.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./es.function.name-b230e7d4.js";
import "./es.string.iterator-5de8a61e.js";
import "./index-5d0f31c6.js";
import "./es.object.keys-9d66766f.js";
import "./an-instance-6efcfd6c.js";
import "./inherit-if-required-f068457b.js";
import "./set-species-5ede2ed0.js";
import "@ucl/shared-icons";
import "./aria.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import "./useWindowSize.js";
import "./modalWindow.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./useClient.js";
import "./disclosure.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./combineRefs-c9ad2c39.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./iconButton.js";
import "./button.js";
import "./index-55eee02a.js";
import "./tslib.es6-59e1c9d8.js";
import "./hooks_internal.js";
import "./analytics.js";
import "./screenReaderOnly.js";
import "./accessibility.js";
var tt = ["id"], ot = /* @__PURE__ */ W.div.withConfig({
  displayName: "photoGallery__PhotoGalleryWrapper",
  componentId: "sc-11yqt6x-0"
})(["&.PhotoGallery{", ";}"], function(r) {
  var e = r.theme.components.photoGallery;
  return w(Object.assign({}, e.PhotoGalleryWrapper));
}), rt = /* @__PURE__ */ W.div.withConfig({
  displayName: "photoGallery__PhotoGalleryThumbnailItemWrapper",
  componentId: "sc-11yqt6x-1"
})(["&.PhotoGallery__thumbnail_item_wrapper{", ";}"], function(r) {
  var e = r.theme.components.photoGallery;
  return w(Object.assign({}, e.PhotoGalleryThumbnailItemWrapper));
});
function Vo(r) {
  var e = r.galleryData, d = r.disableHoverZoom, L = d === void 0 ? !1 : d, g = r.autoImageChange, M = g === void 0 ? !1 : g, y = r.imageInterval, T = y === void 0 ? 3e3 : y, v = r.accessibilityOptions, k = v === void 0 ? {
    lightbox: {}
  } : v, l = r.onImageClick, S = r.separator, q = r.variant, N = Q({
    label: "PhotoGallery"
  }), b = h([]), I = b[0], z = b[1], G = h(!1), K = G[0], x = G[1], P = h(1), $ = P[0], H = P[1], O = B({});
  J(function() {
    var i = R(e);
    z(i);
  }, [e]);
  var R = function(t) {
    return t.map(function(o, m) {
      return {
        size: o.size,
        images: o.images.map(function(s) {
          return s.map(function(u) {
            return Object.assign({}, u, {
              id: m + 1
            });
          });
        })
      };
    });
  }, Z = function(t) {
    return t.flatMap(function(o) {
      return o.images.flatMap(function(m) {
        return m;
      });
    });
  }, _ = Z(I), C = function(t) {
    H(t), x(!0);
  }, E = function(t) {
    x(!1);
    var o = O.current[t];
    o && setTimeout(function() {
      o.focus();
    }, 100);
  }, U = function(t, o) {
    (t.code === "Enter" || t.code === "Space") && (t.preventDefault(), C(o), l == null || l(t, o));
  }, A = function(t, o) {
    l == null || l(t, o), C(o);
  };
  return /* @__PURE__ */ Y(ot, Object.assign({
    className: j(["PhotoGallery"])
  }, N, {
    children: [I.map(function(i, t) {
      return /* @__PURE__ */ a(f, {
        size: i.size,
        disableHoverZoom: L,
        children: i.images.map(function(o, m) {
          return /* @__PURE__ */ a(f.Wrapper, {
            children: o.map(function(s, u) {
              var c = s.id, p = F(s, tt);
              return /* @__PURE__ */ a(rt, {
                className: j(["PhotoGallery__thumbnail_item_wrapper"]),
                tabIndex: 0,
                role: "button",
                ref: function(n) {
                  return O.current[c] = n;
                },
                onClick: function(n) {
                  return A(n, c);
                },
                onKeyDown: function(n) {
                  return U(n, c);
                },
                children: /* @__PURE__ */ a(f.Item, {
                  children: /* @__PURE__ */ a(V, Object.assign({
                    objectFit: "cover",
                    variant: "none",
                    ratio: "16/9",
                    id: c.toString()
                  }, p, {
                    src: (p == null ? void 0 : p.thumbnail) || (p == null ? void 0 : p.src)
                  }))
                })
              }, u);
            })
          }, m);
        })
      }, t);
    }), _.length && /* @__PURE__ */ a(X, {
      images: _,
      onClose: E,
      isOpen: K,
      autoImageChange: M,
      imageInterval: T,
      activeIndex: $,
      accessibilityOptions: k.lightbox,
      separator: S,
      variant: q
    })]
  }));
}
export {
  Vo as PhotoGallery
};
